import axios from 'axios';
import { getBaseUrlAnalista, ensureProtocol } from '../config/backend';

function getBase() {
  return getBaseUrlAnalista() || ensureProtocol(localStorage.getItem('ipBackend2') || '');
}
function getAuthHeaders() {
  const token = localStorage.getItem('token');
  return token ? { Authorization: token.startsWith('Bearer ') ? token : 'Bearer ' + token } : {};
}

export async function sugerirClassificacao(satNum) {
  const base = getBase();
  if (!base || !satNum) return null;
  try {
    const res = await axios.post(base + '/ia-assist/classificacao', { satNum }, { headers: getAuthHeaders(), timeout: 30000 });
    return res?.data ?? null;
  } catch (err) { return { erro: err?.response?.data?.error || 'Erro ao classificar.' }; }
}

export async function chamadosSemelhantes(satNum) {
  const base = getBase();
  if (!base || !satNum) return null;
  try {
    const res = await axios.post(base + '/ia-assist/semelhantes', { satNum }, { headers: getAuthHeaders(), timeout: 30000 });
    return res?.data ?? null;
  } catch (err) { return { erro: err?.response?.data?.error || 'Erro ao buscar semelhantes.' }; }
}
